/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [{
  action: 'getDealReceiptsByCompositeKey',
  message: messages.SUCCESS_GET_DEAL_RECEIPTS_BY_COMPOSITE_KEY,
  method: 'GET',
  path: '/deal-receipts/:compositeKey',
  payloadType: 'collection',
  permissionIdentity: permissionIdentities.GET_DEAL_RECEIPT,
  requestSchema: requestSchemas.dealReceipts.getDealReceiptsByCompositeKey,
  scopes: [scopes.DEFAULT],
}];
